import React, { FC } from 'react'

import EmptyImage from 'assets/images/empty.png'

import styles from './_.module.css'

const EmptyMessage: FC = () => {
  return (
    <section className={styles.emptyMessageContainer}>
      <img src={EmptyImage} alt="no activity found" />
      <div className={styles.helpText}>
        <p>
          Reach out to the writer or Pepper team on anything related to this
          assignment.
        </p>
      </div>
    </section>
  )
}

export default EmptyMessage
